import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import "../../styles/shipping-styles.scss"
import FeatherIcon from 'feather-icons-react';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { toast } from 'react-toastify'
import LoadingSkeleton from 'components/Multipliers/Pages/BrandMultiplier/Includes/LoadingSkeleton'
import SortDeliveryView from './Includes/SortDeliveryView'
import { getShippings, sortShipping } from 'utlis/Apis/Shipping_API'
import { ERROR_WHILE_FETCHING_SHIPPINGS } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_UPDATING_SHIPPING } from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'


function SortDelivery(props) {
    // props
    const { authState } = props

    const [shippings, setShippings] = useState([])
    const [loading, setLoading] = useState(true)

    // store url
    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        setLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getShippings(headers).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setShippings(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(resData.message || ERROR_WHILE_FETCHING_SHIPPINGS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getShippings `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setLoading(false)
                }
            })
        })
    }, [authState])

    const updateList = (list) => {
        setShippings(arr => [...list])
        const ids = []
        list.forEach(element => {
            ids.push(element.id)
        });
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        sortShipping(headers, { sort_array: ids }).then(res => {
            const resData = res.data
            if (resData && resData.error) {
                toast.dismiss(
                    setLoading(true),
                );
                toast.error(ERROR_WHILE_UPDATING_SHIPPING, {
                    autoClose: 3000,
                    onClose: () => {
                        setLoading(false)
                    }
                })
            }
        })

    }

    return (
        <section id="app-product-filters" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-product-filters">
                    <div className="app-header-wrapper mb-3">
                        <div className="back-button-wrapper mb-2">
                            <Link to={storeUrl + "/settings/shippings"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                                <FeatherIcon
                                    icon="arrow-left"
                                    size="14"
                                    className="icon me-1" />
                                <span>Back</span>
                            </Link>
                        </div>
                        <p className="app-heading text-capitalize">Sort delivery options</p>
                    </div>

                    <Row className="product-filter-left-content">
                        <Col lg={3} md={12}>
                            <p className="product-filter-desc">
                                Delivery options will be shown for the customer in the specified order. The first matching method will be selected by default.
                            </p>
                        </Col>

                        <Col lg={9} md={12} className="product-filter-right-content">
                            {loading ? <LoadingSkeleton /> : <SortDeliveryView
                                shippings={shippings}
                                updateList={updateList}
                                loading={loading}
                            />}
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(SortDelivery)